import React from 'react';

import css from './SectionWhyMarketplaceExists.module.css';
import classNames from 'classnames';
import { H2, H3, NamedLink } from '../../../components';

const clientsBenefits = [
  'AboutUsPage.whyMarketplaceExists.benefits1',
  'AboutUsPage.whyMarketplaceExists.benefits2',
  'AboutUsPage.whyMarketplaceExists.benefits3',
  'AboutUsPage.whyMarketplaceExists.benefits4',
  'AboutUsPage.whyMarketplaceExists.benefits5',
  'AboutUsPage.whyMarketplaceExists.benefits6',
  'AboutUsPage.whyMarketplaceExists.benefits7',
  'AboutUsPage.whyMarketplaceExists.benefits8',
  'AboutUsPage.whyMarketplaceExists.benefits9',
];

const SectionWhyMarketplaceExists = props => {
  const { intl, className } = props;
  return (
    <div className={classNames(css.root, className)}>
      <H2 className={css.h2}>
        {intl.formatMessage(
          { id: 'AboutUsPage.whyMarketplaceExists.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H2>
      <div className={css.section}>
        <H3 className={css.h3}>
          {intl.formatMessage({ id: 'AboutUs.whyMarketplaceExists.musiciansHeading' })}
        </H3>
        <p className={css.text}>
          {intl.formatMessage(
            { id: 'AboutUs.whyMarketplaceExists.musiciansText' },
            { link: text => <NamedLink name="ArtistHelpPage">{text}</NamedLink> }
          )}
        </p>
      </div>
      <div className={css.section}>
        <H3 className={css.h3}>
          {intl.formatMessage({ id: 'AboutUs.whyMarketplaceExists.clientsHeading' })}
        </H3>
        <p className={css.text}>
          {intl.formatMessage({ id: 'AboutUs.whyMarketplaceExists.clientsText' })}
        </p>
        <ul className={css.list}>
          {clientsBenefits.map(textId => (
            <li className={css.item} key={textId}>
              {intl.formatMessage({ id: textId })}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SectionWhyMarketplaceExists;
